import { SparkCluster } from "@motley/design"
import { Link } from "@tanstack/react-router"

export default function CTA() {
  return (
    <section className="flex flex-col items-center gap-8 px-6 py-14 sm:py-20">
      <SparkCluster />
      <Link
        to="/auth"
        className="relative inline-block rounded-[10px] bg-spark-orange px-14 py-4 text-lg font-medium text-white transition-transform before:absolute before:-inset-1.5 before:animate-[cta-pulse_2.5s_ease-in-out_infinite] before:rounded-[14px] before:bg-spark-orange before:opacity-0 hover:scale-[1.02]"
      >
        Sign Up
      </Link>
    </section>
  )
}
